export default {
  namespaced: true,
  state: {
    user_info: {
      is_superuser: true,
      model_ids: [],
    },
  },
  mutations: {
    set_model_ids(state, user_info) {
      state.user_info = user_info;
    },
  },
  actions: {},
  getters: {},
};
